import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import { useMediaQueries } from '../../usecontext/UseProvider';
import { getOurStoryPurpose } from '../../services/OurStoryPurpose';

const StoryPerpose = () => {
    const { isSmallScreen } = useMediaQueries();
    const [storyData, setStoryData] = useState([])

    const getOurStoryPurposeData = async () => {
        try {
            const response = await getOurStoryPurpose();
            setStoryData(response?.ourStoryPurpose);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getOurStoryPurposeData();
    }, []);

    return (
        <Container
            sx={{
                pt: { lg: 8, xs: 3 },
                pb: 3,
                textAlign: 'center',
            }}
        >
            <Typography
                data-aos="fade-up"
                variant={isSmallScreen ? 'h5' : 'h4'}
                sx={{ fontWeight: 700 }}
                gutterBottom
            >
                Our Story and Purpose
            </Typography>
            <Typography data-aos="fade-up" variant="subtitle1" >
                Learn about our journey, vision, and mission that inspire every swing we create.
            </Typography>
            <Grid container spacing={{ sm: 3, xs: 1 }} sx={{ py: { lg: 6, xs: 3 }, px: { sm: 3, xs: 0 } }}>
                {storyData?.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index} data-aos="fade-up">
                        <Card
                            sx={{
                                boxShadow: '0px 0px 59px 0px #0000000D',
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                transition: 'box-shadow 0.5s ease, transform 0.5s ease',
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                    // '.hovereffect': {
                                    //     backgroundColor: '#01A0E2',
                                    //     transition: 'background-color 0.5s ease',

                                    // },
                                    // 'img.hovereffect': {
                                    //     transition: 'filter 0.5s ease',
                                    // },
                                },
                                p: { sm: 2, xs: 0 },
                                zIndex: 1,
                                height: '100%',
                            }}
                        >
                            <Box
                                className="hovereffect"
                                sx={{
                                    border: '1px solid #01A0E2',
                                    height: '85px',
                                    width: '85px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '50%',
                                    zIndex: 2,
                                    transition: 'background-color 0.5s ease',
                                }}
                            >
                                {/* Use the SVG as an image */}
                                <img
                                    src={item?.image?.url}
                                    alt={item.title}
                                    className="hovereffect"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        transition: 'filter 0.5s ease',
                                    }}
                                />
                            </Box>

                            <CardContent>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        mb: 1,
                                        fontWeight: 600,
                                    }}
                                >
                                    {item.title}
                                </Typography>
                                <Typography variant='body1' sx={{ fontSize: '16px' }}>{item.content}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container >
    );
};

export default StoryPerpose;